import daerah from './daerah';

const master = {
  namespaced: true,

  state() {
    return {};
  },

  mutations: {},

  actions: {},

  modules: {
    daerah,
  },
};
export default master;
